var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-tablet",
    clipPath: "url(#clip0_2893_11017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3103 6.87866L17.1216 2.68897C16.9823 2.54965 16.8169 2.43913 16.6349 2.36373C16.4529 2.28832 16.2578 2.24951 16.0608 2.24951C15.8638 2.24951 15.6687 2.28832 15.4867 2.36373C15.3047 2.43913 15.1393 2.54965 15 2.68897L3.43969 14.2502C3.2998 14.389 3.18889 14.5542 3.11341 14.7362C3.03792 14.9183 2.99938 15.1135 3.00001 15.3105V19.5002C3.00001 19.898 3.15804 20.2796 3.43935 20.5609C3.72065 20.8422 4.10218 21.0002 4.50001 21.0002H8.6897C8.88675 21.0009 9.08197 20.9623 9.26399 20.8868C9.44602 20.8113 9.61122 20.7004 9.75001 20.5605L21.3103 9.00022C21.4496 8.86093 21.5602 8.69556 21.6356 8.51355C21.711 8.33153 21.7498 8.13645 21.7498 7.93944C21.7498 7.74243 21.711 7.54735 21.6356 7.36534C21.5602 7.18333 21.4496 7.01795 21.3103 6.87866ZM4.81032 15.0002L13.2806 6.52991L14.8444 8.0946L6.37501 16.564L4.81032 15.0002ZM4.50001 16.8105L7.1897 19.5002H4.50001V16.8105ZM9.00001 19.1899L7.43532 17.6252L15.9056 9.15491L17.4694 10.7196L9.00001 19.1899Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2893_11017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPencil);
export default __webpack_public_path__ + "static/media/BlackPencil.6f9d2f4fa0f8d009ec8114ebf24c48f5.svg";
export { ForwardRef as ReactComponent };